import { render, staticRenderFns } from "./DidNotAttend.vue?vue&type=template&id=72bc2424"
import script from "./DidNotAttend.vue?vue&type=script&lang=js"
export * from "./DidNotAttend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports